import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

class YearsDropdownList extends Component {
	constructor(props) {
		super(props);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	handleSelectChange(selectedId) {
		const { onChange } = this.props;
		if (onChange) {
			onChange(selectedId);
		}
	}

	render() {
		const { data, name, value, defaultValue, onChange, hideEmptyOption, emptyLabel,
			activeYear, ...rest } = this.props;

		const selectedYear = value || activeYear;
		const selected = selectedYear && data.find(x => x === selectedYear);

		return <Dropdown>
			<Dropdown.Toggle title={<span>{selected || emptyLabel} <FontAwesomeIcon icon={faChevronDown} /></span>} noCaret {...rest} />
			<Dropdown.Menu className='dashboard-dropdown-menu'>
				{hideEmptyOption || <MenuItem key={0} eventKey='' onSelect={this.handleSelectChange}><span>{emptyLabel}</span></MenuItem>}
				{data.map(year => {
					const isActive = activeYear && year === activeYear;
					return <MenuItem key={year} eventKey={year} onSelect={this.handleSelectChange}>
						<span className={isActive ? 'term-active' : ''}>{year}</span>
					</MenuItem>;
				})}
			</Dropdown.Menu>
		</Dropdown>;
	}
}

const mapStateToProps = (state) => {
	const {
		lookups: { years }
	} = state;

	const today = new Date();
	const activeYear = today.getFullYear();

	return {
		data: Object.values(years),
		activeYear
	};
};

export default connect(mapStateToProps, {})(YearsDropdownList);